<!--

    Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
    Ministerpräsidenten des Landes Schleswig-Holstein
    Staatskanzlei
    Abteilung Digitalisierung und zentrales IT-Management der Landesregierung

    Lizenziert unter der EUPL, Version 1.2 oder - sobald
    diese von der Europäischen Kommission genehmigt wurden -
    Folgeversionen der EUPL ("Lizenz");
    Sie dürfen dieses Werk ausschließlich gemäß
    dieser Lizenz nutzen.
    Eine Kopie der Lizenz finden Sie hier:

    https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12

    Sofern nicht durch anwendbare Rechtsvorschriften
    gefordert oder in schriftlicher Form vereinbart, wird
    die unter der Lizenz verbreitete Software "so wie sie
    ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
    ausdrücklich oder stillschweigend - verbreitet.
    Die sprachspezifischen Genehmigungen und Beschränkungen
    unter der Lizenz sind dem Lizenztext zu entnehmen.

-->
<h4 class="sr-only">Zuständige Stellen</h4>

@if (organisationsEinheiten.length > 0) {
  <ul class="list-outside list-disc pl-4" data-test-class="organisations-einheiten">
    @for (group of organisationsEinheiten | slice: 0 : MAX_GROUPS_TO_DISPLAY; track $index) {
      <li>{{ group }}</li>
    }
  </ul>
  @if (organisationsEinheiten.length > MAX_GROUPS_TO_DISPLAY) {
    <p class="text-placeholder pl-4">und {{ organisationsEinheiten.length - MAX_GROUPS_TO_DISPLAY }} weitere</p>
  }
} @else {
  <p data-test-class="no-organisations-einheit-text">keine zuständige Stelle zugewiesen</p>
}
